import { render, staticRenderFns } from "./TeamMain.vue?vue&type=template&id=be171918&scoped=true"
import script from "./TeamMain.vue?vue&type=script&lang=js"
export * from "./TeamMain.vue?vue&type=script&lang=js"
import style0 from "./TeamMain.vue?vue&type=style&index=0&id=be171918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be171918",
  null
  
)

export default component.exports